module.exports = __webpack_public_path__ + "img/energy-shield-equipment.625fd51e.png";